import 'prismjs/plugins/toolbar/prism-toolbar';
export { default as plugin } from 'prismjs/plugins/toolbar/prism-toolbar.css';
